import { useState } from 'react';

interface AvatarProps {
  src?: string | null;
  name: string;
  className?: string;
}

/**
 * Avatar image with onError fallback to initial letter.
 * When the image fails to load (e.g. offline, deleted), it hides the img
 * and falls through to the initial letter behind it.
 */
export function AvatarImg({ src, name, className = 'w-full h-full object-cover' }: AvatarProps) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return <>{name[0]}</>;
  }

  return (
    <img
      src={src}
      alt=""
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
